import { render } from "./NotSupported.vue?vue&type=template&id=3d4971c6"
import script from "./NotSupported.vue?vue&type=script&lang=js"
export * from "./NotSupported.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__